import axios from "axios";

export const baseApi = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    "Content-type": "application/json",
  },
});
